import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setEdits, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default MultiCellSelectShortcuts = ->

  [{
    columns,
    count,
    edits,
    selection
  }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      dispatch(setSelection([selection[1][0], Math.min(selection[1][1] + 1, count)]))
      dispatch(setSelectionType(selectionTypes.CELL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'up'
    fn: ->
      if selection[1][1] > 0
        dispatch(setSelection([selection[1][0], selection[1][1] - 1]))
        dispatch(setSelectionType(selectionTypes.CELL))
      else
        dispatch(setSelection(selection[1][0]))
        dispatch(setSelectionType(selectionTypes.COL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'left'
    fn: ->
      if selection[1][0] > 0
        dispatch(setSelection([selection[1][0] - 1, selection[1][1]]))
        dispatch(setSelectionType(selectionTypes.CELL))
      else
        dispatch(setSelectionType(selectionTypes.ROW))
        dispatch(setSelection(selection[1][1]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['right', 'tab']
    fn: ->
      dispatch(setSelection([selection[1][0] + 1, selection[1][1]]))
      dispatch(setSelectionType(selectionTypes.CELL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+left'
    fn: ->
      if selection[1][0] > 0
        dispatch(setSelection([selection[0], [selection[1][0] - 1, selection[1][1]]]))
      else
        dispatch(setSelection([selection[0][1], selection[1][1]]))
        dispatch(setSelectionType(selectionTypes.MULTI_ROW))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+right'
    fn: ->
      dispatch(setSelection([selection[0], [selection[1][0] + 1, selection[1][1]]]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+up'
    fn: ->
      if selection[1][1] > 0
        dispatch(setSelection([selection[0], [selection[1][0], selection[1][1] - 1]]))
      else
        dispatch(setSelection([selection[0][0], selection[1][0]]))
        dispatch(setSelectionType(selectionTypes.MULTI_COL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+down'
    fn: ->
      dispatch(setSelection([selection[0], [selection[1][0], selection[1][1] + 1]]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      [[x1, y1], [x2, y2]] = selection
      newEdits = [y1..y2].reduce((acc, i) ->
        {
          acc...,
          [i]: ([x1..x2].reduce(((acc, j) ->
            {
              edits[i]...,
              acc...,
              [j]: emptyCell(columns[j])
            }
          ), {}))
        }
      , edits)
      dispatch(setEdits({
        prevEdits: edits
        nextEdits: newEdits
      }))
    temporary: true
    expr: WeaverService.userCanEdit()
    watchers: [selection, edits]
  }])

  <div />





